import useRoute from"./useRoute";const useDarkFromRoute=()=>{const e=useRoute();return e?.fields?.isDarkMode?.value};export default useDarkFromRoute;